function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-mobile-alt",
  d: "M19.5.375H3.75A3.376 3.376 0 00.375 3.75V33a3.376 3.376 0 003.375 3.375H19.5A3.376 3.376 0 0022.875 33V3.75A3.376 3.376 0 0019.5.375zm-7.875 33.75a2.25 2.25 0 112.25-2.25 2.248 2.248 0 01-2.25 2.25zm7.875-7.594a.846.846 0 01-.844.844H4.594a.846.846 0 01-.844-.844V4.594a.846.846 0 01.844-.844h14.062a.846.846 0 01.844.844z",
  fill: "none",
  stroke: "#3c00dc",
  strokeWidth: 0.75
});

function SvgMobileinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.25,
    height: 36.75,
    viewBox: "0 0 23.25 36.75"
  }, props), _ref);
}

export default SvgMobileinline;